<template>
  <BaseNew
    @new-confirm-action="emitNfe"
    @new-cancel-action="resetForm"
    @new-open-action="mainLoadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    :modelNameSingular="modelNameSingular"
    newCreateButtonLabel="Emitir CC-e"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :inlineAddButton="true"
    addButtonIcon="mdi-card-plus"
    :nfe="nfe"
    newSaveButtonLabel="Emitir CC-e"
    :useModelInsteadOfButton="useModelInsteadOfButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        @formLoading="pageLoading=true"
        @formStopLoading="pageLoading=false"
        @formErrors="errorsFromForm"
        :printing="printing"
        id="printableELement"
        formType="new"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      printing: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    nfe: {
      type: Object,
      default: null,
    },
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Carta de Correção"
    }
  },
  components: {
    Form: Form,
    BaseNew: BaseNew,
  },
  methods: {
    mainLoadServerEntry: function() {
      // console.log("multiSale", this.multiSale);

      // if (this.multiSale){
      //   this.cashFlow = {id: this.multiSale.sales[0]};
      // }
        // console.log("cashFlow", this.cashFlow)
      // if (this.cashFlow) {
        this.loadServerEntry();
      // } else if (this.multiSale) {
      //   this.loadServerEntryMultiSale();
      // }
    },
    loadServerEntry: function() {
      this.error = null;
      this.loading = false;
      // console.log("nfe", this.nfe);
      var id = this.nfe.id;
      // console.log("id", id);
      this.entry = {}
      this.entry.nfeId = id;
      // this.entry.correcao= "";
      console.log(this.entry);
      // console.log("cashflow", this.cashFlow);

      // var id = this.cashFlow?.id || this.multiSale?.sales[0];
      // this.$apollo
      //   .query({
      //     query: LOAD_NEW_OUTBOUND_NFE_QUERY,
      //     fetchPolicy: "no-cache",
      //     variables: {
      //       saleId: id
      //     }
      //   })
      //   .then(response => {
      //     this.entry = response.data.accountContext.nfe;
      //     // console.log('this.entry', this.entry.performance);
      //     this.entry.cashFlowId = id;
      //     if (this.multiSale){
      //       for(var i = 0; i < this.multiSale.sales.length; i++){
      //         var sale = this.multiSale.sales[i];
      //         // console.log("sale", );
      //         this.entry.cashFlowIdsAttribute.push(sale);
      //       }
      //     }else{
      //       this.entry.cashFlowIdsAttribute.push(id);
      //     }          
      //     this.extraData = response.data;
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));
    },
    createServerEntry: function(nfpe) {
      // console.log("NFP-e", nfpe, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(nfpe, this.entry.validations));
      this.pageLoading = true;
      console.log("cse", nfpe);
      this.$apollo
        .mutate({
          mutation: CREATE_NFE_CCE_MUTATION,
          variables: {
            input: nfpe //this.deepFilterEntryWithAllowedFieldsForMutation(nfpe, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.issueNfpeCce.errors
          // console.log(errors)
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created");
            this.pageLoading = false;
            this.$router.push({ name: "OutboundNfe"});
            this.resetForm();
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    emitNfe: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    },
    errorsFromForm: function(errors) {
      this.formErrors = this.formErrors.concat(errors);
    }
  }
};

const CREATE_NFE_CCE_MUTATION = gql `
  mutation($input: IssueNfpeCceInputObject!) {
    issueNfpeCce(input: $input) {
      cce {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
